import React, { Fragment } from 'react';
import { omit } from 'lodash';

import styles from './userSavedSearchesPageStyles';

import XMarkIcon from 'buyside/svgs/x_mark.svg';

const DeletedSavedIdeaSearches = ({
  deletedSearches,
  handleRestoreSearchAlert,
  removeFromSoftDelete
}) => (
  <Fragment>
    {Object.keys(deletedSearches).map(alertId => {
      const alert = deletedSearches[alertId];
      return (
        <div key={alertId} className={styles.deleteMessage}>
          Search "{alert.name}" deleted successfully.
          <strong className={styles.undoButton} onClick={() => handleRestoreSearchAlert(alert)}>
            Undo
          </strong>
          <XMarkIcon
            className={styles.removeIcon}
            onClick={() => removeFromSoftDelete(omit(deletedSearches, alertId))}
          />
        </div>
      );
    })}
  </Fragment>
);

export default DeletedSavedIdeaSearches;
